/**
 * Returns a slightly darker or lighter hex color
 * @param hex - Hex color string (with or without #)
 * @param percent - Percentage to shade (negative to darken, positive to lighten)
 */
export function shadeHex(hex: string, percent: number): string {
  const n = hex.replace("#", "");
  const num = parseInt(
    n.length === 3 ? n.split("").map((c) => c + c).join("") : n,
    16
  );
  const r = Math.min(
    255,
    Math.max(0, ((num >> 16) & 0xff) + Math.round((percent / 100) * 255))
  );
  const g = Math.min(
    255,
    Math.max(0, ((num >> 8) & 0xff) + Math.round((percent / 100) * 255))
  );
  const b = Math.min(
    255,
    Math.max(0, (num & 0xff) + Math.round((percent / 100) * 255))
  );
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

